/**
 * Pure lookup logic for legacy WordPress URL redirects. Kept separate from the
 * React component so it can be unit-tested without pulling in react-router-dom.
 */

// Keys are lowercased, no-trailing-slash paths (except root).
// Values are the new SPA paths (React Router will navigate to them).
export const LEGACY_MAP = {
  // Estonian legacy paths (from the old WordPress site)
  "/hinnad": "/hinnakiri",
  "/kontaktid": "/kontakt",
  "/meist": "/",
  "/teenus": "/teenused",
  "/diabeedioe-teenused": "/teenused",
  "/jalaoe-teenused": "/teenused",
  "/kilpnaarme-uuringud": "/teenused",
  "/kilpnaarme-uuring": "/teenused",
  "/kilpnaarme-ultraheli": "/teenused",
  "/diabeedi-uuringud": "/teenused",
  "/endokrinoloog": "/arstid",
  "/arst": "/arstid",
  "/vastuvott": "/kontakt",
  "/broneerimine": "/kontakt",
  "/hinnakiri.html": "/hinnakiri",
  "/index.html": "/",
  "/index.php": "/",

  // Additional legacy ET paths surfaced by Google Search Console (2026-07)
  "/endokrinoloogi-teenused": "/teenused",
  "/endokriinoe-teenused": "/teenused",
  "/kilpnaarme-uletalitlus": "/haigused",
  "/kilpnaarme-alatalitlus": "/haigused",
  "/kilpnaarme-solmed": "/haigused",
  "/2-tuupi-diabeet": "/haigused/2-tuupi-diabeet",
  "/digiregistratuur": "/kontakt",
  "/patsiendile": "/kontakt",
  "/endokrinoloogia-kliinik-tallinnas": "/",
  "/teenused-ru": "/ru/услуги",

  // Russian legacy disease pages (no longer indexable — redirect to /haigused)
  "/ru/гиперфункция-щитовидной-железы": "/ru/заболевания",
  "/ru/гипофункция-щитовидной-железы": "/ru/заболевания",

  // Additional legacy RU (Cyrillic) paths surfaced by GSC (2026-07)
  "/ru/клиника-эндокринологии-в-таллинне": "/ru",
  "/ru/эндокринолог-таллиннская-клиника-эн": "/ru",
  "/ru/диабет-2-го-типа": "/ru/заболевания/сахарный-диабет-2-типа",
  "/ru/узел-или-узлы-в-щитовидной-железе": "/ru/заболевания",
  "/ru/пациент": "/ru/контакты",
  "/ru/услуги-эндокринолога": "/ru/услуги",
  "/ru/эндокринная-медсестра": "/ru/услуги",
  "/ru/услуги-медсестры-по-уходу-за-ногами": "/ru/услуги",
  "/ru/услуги-диабетической-медсестры": "/ru/услуги",
  "/ru/услуги-диабетической-сестры": "/ru/услуги",
  "/ru/гипофункция-щитовидной-желез": "/ru/заболевания",
  //
  // NOTE: /ru/teenused, /en/services etc. are handled by App.js LegacyRoutes
  // via React Router (they hit real Route components with <Navigate replace>).
  // See buildLegacyRoutes() in App.js.
};

/**
 * Look up a legacy path in the map. Returns the new path or null.
 * - URL-decodes Cyrillic (encoded by the browser)
 * - Lowercases (case-insensitive match)
 * - Strips trailing slash (except root)
 * - Falls back to raw path if decoding fails (malformed input)
 */
export function resolveLegacyPath(pathname) {
  if (!pathname) return null;
  let p;
  try {
    p = decodeURIComponent(pathname);
  } catch {
    p = pathname;
  }
  p = p.toLowerCase();
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return LEGACY_MAP[p] || null;
}
